import React from 'react'
import PropTypes from 'prop-types'

export const FileSelectUpload = ({ id, heading, useFullWidth, onFileSelect, uploadButton, uploadButtonText, disabled, error, errorMessage }) => (
  <div className={`slds-form-element ${error ? 'slds-has-error': ''}`}>
    {heading &&
      <span className='slds-form-element__label' id='file-selector-id'>
        {heading}
      </span>
    }
    <div className='slds-form-element__control'>
      <div className={`slds-file-selector slds-file-selector_files ${useFullWidth ? 'slds-size_1-of-1' : ''}`}>
        {/* <div className='slds-file-selector__dropzone'> */}
         {/* will use ^^^ when we want the capability of dragging&dropping files to upload */}
          <input
            type='file'
            className='slds-file-selector__input slds-assistive-text'
            // accept='image/png'  currently we accept all file type for uploads
            id={`file-upload-input-${id}`}
            aria-describedby='file-selector-id'
            onChange={onFileSelect}
            disabled={disabled}
          />
          <label
            className={`slds-file-selector__body ${useFullWidth ? 'slds-size_1-of-1' : ''}`}
            htmlFor={`file-upload-input-${id}`}>
            {uploadButton ||
              <span className='slds-file-selector__button slds-button slds-button_neutral'>
                {uploadButtonText || 'Upload files'}
              </span>
            }
            {/* <span className='slds-file-selector__text slds-medium-show'>or Drop Files</span> */}
          </label>
        </div>
      {/* </div> */}
    </div>
    {error &&
      <div className='slds-form-element__help' id='error-01'>
        {errorMessage || 'Something went wrong with file selection'}
      </div>
    }
  </div>
)

FileSelectUpload.propTypes = {
  id: PropTypes.string,
  heading: PropTypes.string,
  useFullWidth: PropTypes.bool,
  uploadButton: PropTypes.bool,
  uploadButtonText: PropTypes.string,
  onFileSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string
}

FileSelectUpload.defaultProps = {
  id: Math.floor(Math.random() * 1000)
}



// WEBPACK FOOTER //
// ./src/components/file-select-upload/index.js